import { render, staticRenderFns } from "./PowerBiReports.vue?vue&type=template&id=f3af1d9c&scoped=true"
import script from "./PowerBiReports.vue?vue&type=script&lang=ts"
export * from "./PowerBiReports.vue?vue&type=script&lang=ts"
import style0 from "./PowerBiReports.vue?vue&type=style&index=0&id=f3af1d9c&prod&lang=scss&scoped=true"
import style1 from "./PowerBiReports.vue?vue&type=style&index=1&id=f3af1d9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3af1d9c",
  null
  
)

export default component.exports